import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path d="M21.66,7.51l-.5-2A2,2,0,0,0,19.64,4l-.47-.93A2,2,0,0,0,17.38,2H6.62A2,2,0,0,0,4.83,3.11L4.36,4A2,2,0,0,0,2.84,5.51l-.5,2A2.05,2.05,0,0,0,2.28,8,2,2,0,0,0,4,10v9a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V10a1.2,1.2,0,0,0,.2,0A2,2,0,0,0,21.66,7.51ZM4.78,6h.84l1-2H17.38l1,2h.84l.5,2H4.28ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V10H18Z" />,
  "GuardianTrash"
);
